/** Construct player URLs, never trust supplied iframe sources. */
export function parseSpotifyUrl(input: string) {
  try {
    const url = new URL(input);
    if (url.protocol !== 'https:' || url.hostname !== 'open.spotify.com' || url.port || url.username || url.password)
      return null;
    const match = /^\/(?:intl-[a-z]{2}\/|embed\/)?(track|album|artist|playlist)\/([A-Za-z0-9]{22})\/?$/.exec(
      url.pathname,
    );
    if (!match) return null;
    const kind = match[1];
    const id = match[2];
    return {
      kind,
      id,
      href: `https://open.spotify.com/${kind}/${id}`,
      src: `https://open.spotify.com/embed/${kind}/${id}`,
    };
  } catch {
    return null;
  }
}
